
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from "react";
import RegionsList from "../../components/regionsList";
import PropTypes from "prop-types";
import TimeFilter from "../../components/timeFilter";
import { connect } from "react-redux";
import Helpers from '../../../helpers/helperFunctions';
import Config from "../../../config/main";

class LeftMenu extends Component {
    constructor (props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick () {
        Helpers.hasClassName(".main-wrapper", "regionClosed") ? Helpers.replaceClassName(".main-wrapper", "regionClosed", "regionOpened") : Helpers.replaceClassName(".main-wrapper", "regionOpened", "regionClosed");
    }

    render () {
        let {
            sportAlias,
            timeFilter,
            isAsian,
            setTimeFilter,
            gameType,
            regionId,
            competitionId
        } = this.props;
        return (<div className={`select-game-nav-list ${gameType}`} onClick={(e) => e.stopPropagation()}>
            <div className={`region-closed ${gameType === "live" ? "live" : ""}`} onClick={this.handleClick}/>
            {gameType === "prematch" && !Config.main.hasDayFilter ? <TimeFilter key={timeFilter}
                timeFilter={timeFilter}
                setTimeFilter={setTimeFilter}/> : null}
            {(this.props.sportAlias !== "all" || Config.main.showRegionsListInLiveMode) && <RegionsList sportAlias={sportAlias}
                timeFilter={timeFilter}
                isAsian={isAsian}
                key={sportAlias + timeFilter + gameType}
                regionId={regionId}
                competitionId={competitionId}
                gameType={gameType}/>
            }
        </div>);
    }
}

LeftMenu.propTypes = {
    isAsian: PropTypes.bool,
    sportAlias: PropTypes.any,
    gameType: PropTypes.string,
    timeFilter: PropTypes.any,
    setTimeFilter: PropTypes.any,
    regionId: PropTypes.any,
    competitionId: PropTypes.any
};

export default connect()(LeftMenu);